import React, { useMemo } from 'react'
import { BundleDataStyled } from './BundleData.styled'
import { useUserStore } from 'Stores/userStoreModuleFed'
import { useGetPlansDetails } from 'Features/accountSettings/api/getPlansDetails'
import { DEFAULT_TIMEZONE, getCountryLabelByCountryValue, toUnixDateRangeFix } from 'Utils/dates'
import { InvalidRequests } from '../Components/InvalidRequests/InvalidRequests'
import { TotalVisits } from '../Components/TotalVisits/TotalVisits'
import { kFormatter } from 'Utils/number'
import { useGetBotMitigationData } from 'Features/home/api/getProductData'
import { useVisitsSummary } from 'Features/home/api/getVisitsSummary'

export const BundleData = () => {
  const { timezoneCountry } = useUserStore()
  const { data: plansDetails, isLoading: isPlandLoading } = useGetPlansDetails()

  const timezone: string = getCountryLabelByCountryValue(timezoneCountry)
  const serverDateConversion = toUnixDateRangeFix(timezoneCountry, {
    from: new Date(plansDetails?.currentPeriodStart || ''),
    to: new Date(),
  })
  const { data: visitsData } = useVisitsSummary(
    {
      startDate: serverDateConversion?.from,
      endDate: serverDateConversion?.to,
      timezone: timezone || DEFAULT_TIMEZONE,
    },
    !isPlandLoading && !!plansDetails?.currentPeriodStart
  )

  const { data: rawData } = useGetBotMitigationData({
    startDate: serverDateConversion?.from || 0,
    endDate: serverDateConversion?.to || 0,
  })

  const bmInvalidRate = useMemo(() => {
    let invalidRateSum = 0
    const invalidRateAvg = 0

    rawData?.summary?.summary?.forEach((item) => {
      invalidRateSum += item?.invalidRate
    })

    return Math.floor(invalidRateSum / (rawData?.summary?.summary?.length || 1))

    return invalidRateAvg
  }, [rawData])

  return (
    <BundleDataStyled>
      <TotalVisits bundle={true} totalVisits={kFormatter(visitsData?.[0].visits) || ''} />
      <InvalidRequests
        bundle={true}
        text={'trial_pre_end_modal.pm_invalid_rate'}
        invalidRequests={
          (
            ((visitsData?.[0].paidInvalidTraffic || 0) / (visitsData?.[0].paidTraffic || 1)) *
            100
          ).toFixed(2) + '%'
        }
      />
      <InvalidRequests
        bundle={true}
        text={'trial_pre_end_modal.bm_invalid_rate'}
        invalidRequests={`${bmInvalidRate}%`}
      />
    </BundleDataStyled>
  )
}
